import { useState, useRef, useLayoutEffect } from 'react';

const useTruncationObserver = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useLayoutEffect(() => {
    if (!ref.current) return;

    const checkTruncation = () => {
      if (ref.current && ref.current.scrollWidth > ref.current.clientWidth) {
        setIsTruncated(true);
      } else {
        setIsTruncated(false);
      }
    };

    // Use ResizeObserver to check for truncation whenever the element's size changes
    const observer = new ResizeObserver(checkTruncation);
    observer.observe(ref.current);

    // Initial check
    checkTruncation();

    return () => {
      observer.disconnect();
    };
  }, []);

  return { ref, isTruncated };
};

export default useTruncationObserver;
